
import Checkbox from '@mui/material/Checkbox'
import PropTypes from 'prop-types'
import React, { Fragment as F, useContext, useEffect } from 'react'

import {
  C,
  logg,
} from '$shared'

/*
 * IncludeUbprs
**/
const IncludeUbprs = (props) => {
  const {
    eol,
    filteredUbprsList,
    selectedUbprs, setSelectedUbprs,
  } = props

  return <div className='IncludeUbprsW' >
    { filteredUbprsList.length && <F>
      <table className='bordered padded' >
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          { filteredUbprsList.map((item, idx) => <tr key={idx} >
              <td>{ [ C.el.br, C.el.h3 ].indexOf(item.value) > -1 ? null :
                <Checkbox
                  checked={selectedUbprs.filter(({ value }) => value === item.value).length == 1 }
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      selectedUbprs.push(item) ;
                      setSelectedUbprs(Object.assign([], selectedUbprs)) ;
                      eol && eol.scrollIntoView({ behavior: 'smooth' }) ;
                    } else {
                      setSelectedUbprs(selectedUbprs.filter(({ value }) => value !== item.value ))
                    }
                  } }
                /> }
              </td>
              <td>
                { [ C.el.br, C.el.h3 ].indexOf(item.value) > -1 ? null : item.label }
                { C.el.h3 === item.value && <b>{item.label}</b> }
              </td>
          </tr>) }
        </tbody>
      </table>
    </F> || null }
  </div>
}
export default IncludeUbprs
IncludeUbprs.propTypes = {
  setSelectedUbprs: PropTypes.func.isRequired,
}
